import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './en.json';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    resources: {
        en: {
            translation: en,
        },
    },
});

export default i18n;
